import lijjatLogo from "../../../asset/images/Lijjat Logo.png";
import lijjatPapad from "../../../asset/images/Lijjat.png";
import lijjatMasala from "../../../asset/images/LijjatMasala.jpg";

export const LIJJAT_BRAND = {
  companyName: "Shri Mahila Griha Udyog Lijjat Papad",
  logo: lijjatLogo,
};

export const getLijjatProductImage = (productCode) => {
  const code = String(productCode || "");

  if (code === "8901441011018") {
    return lijjatMasala;
  }

  return lijjatPapad;
};
